// 当必填项中只输入空格，依然提示 “内容不能为空”
// 我们将验证函数的实现方式修改为返回一个 Promise 对象。在验证过程中，如果输入的值只包含空格，我们使用 reject() 方法
// 来返回一个带有错误消息的 Promise 对象；否则，我们使用 resolve() 方法来返回一个不带任何参数的Promise对象，表示验证通过。
// 当 input 组件不填写内容时，value 为 undefined，当填写内容后再删除 value 为 null，value 为多个空格，value.trim() === ''
// 因此这 3 种情况都要考虑
export const validateWhiteSpace = (rule, value) => {
    return new Promise((resolve, reject) => {
        if (value === undefined || value === null || value.trim() === '') {
            reject('内容不能为空');
        } else {
            resolve();
        }
    });
};

// 首先检查 value 是否为空或只包含 HTML 标签，通过使用正则表达式  /<[^>]+>/g  去除 HTML 标签，
// 对于富文本编辑器中输入多个空格的情况，可以使用正则表达式将空格和其他 HTML 实体从 value 中删除，然后再进行验证。
// 并使用 trim() 方法去除空格后判断长度是否为 0。如果是，我们使用 reject() 方法返回一个带有错误消息的 Promise 对象；
// 否则，我们使用 resolve() 方法返回一个不带任何参数的 Promise 对象，表示验证通过。
export const validateEditorContent = (rule, value) => {
    return new Promise((resolve, reject) => {
        // 如果只有图片，也可以通过验证
        const strippedValue = value.includes("<img") || value.includes("attachment") ? value : value.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, "").trim();
        if (!strippedValue) {
            reject('内容不能为空');
        } else {
            resolve();
        }
    });
};